import React from 'react';
import { Redirect, Link, withRouter } from 'react-router-dom';
import { Layout, Menu, MenuProps, Breadcrumb, Avatar, message, Badge, Row, Space, Dropdown, Tooltip, Select } from 'antd';
import {
    PoweroffOutlined,
    MailOutlined,
    AreaChartOutlined,
    IdcardOutlined,
    PieChartOutlined,
    PlusSquareOutlined,
    UserOutlined,
    AppstoreOutlined,
    ShopOutlined,
    DollarCircleOutlined,
    BuildOutlined,
    ShoppingCartOutlined,
    VideoCameraOutlined,
    DatabaseOutlined,
    SettingOutlined, CopyOutlined, BankOutlined

} from '@ant-design/icons';
import moment from 'moment';
import 'moment/locale/zh-cn';
import '../index.css';
import 'braft-extensions/dist/table.css'

import store from "../store/store.js";
import Znxx from "../public/znxx"

moment.locale('zh-cn');
const { Header, Content, Sider } = Layout;
const { SubMenu } = Menu;

class SiderDemo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            breadcrumb: store.getState().data.navname ? store.getState().data.navname : ['首页'],
            defaultnav: '1',
            current: '/',
            isLogin: store.getState().data.isLogin ? store.getState().data.isLogin : false,
            name: store.getState().data.info.name,
            ISlogin: false
        }
        // props.GET_INFO();
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data)
            this.setState({
                islogin: store.getState().data.isLogin,
                breadcrumb: store.getState().data.navname,
                yuanqu: store.getState().data.yuanqu,
            });
        })
    }

    breadcrumbItem = e => {
        let that = this
        if (this.state.breadcrumb) {
            // 	console.log(this.state.breadcrumb)
            return that.state.breadcrumb.map((item, index) =>

                <Breadcrumb.Item key={index}>{item}</Breadcrumb.Item>)
        }
    }

    componentWillReceiveProps(nextProps) {
        // console.log('路由变化了')
        // 判断跳转路由不等于当前路由
        if (nextProps.location.pathname !== this.props.location.pathname) {
            this.islogin()
            this.getZnxNum()
        }
    }

    getZnxNum = () => {
        let that = this
        fetch('/Geren/msgNum', {
            method: "POST",
        })
            .then(res => res.json())
            .then(data => {
                that.props.GET_JIAOBIAO(data.data)
            })
    }

    islogin() {
        fetch('/Check/checklogin', {
            method: "POST",
        })
            .then(res => res.json())
            .then(data => {
                // ;return
                if (data.state == 1) {
                    this.props.SET_INFO(data.data)
                    this.setState({
                        isLogin: true,
                        ISlogin: true,
                        yuanqu_react: data.yuanqu_react ? data.yuanqu_react : []
                    })
                    if (data.status != 1) {
                        this.setState({
                            ISlogin: false
                        })
                        this.logout();
                    }
                } else {
                    this.logout(1)
                }
            })
    }

    componentDidMount() {
        let that = this
        that.islogin()
        that.getZnxNum()
        let time = setInterval(() => {
            that.islogin()
        }, 600000)
        that.setState({
            time: time
        })
    }

    componentWillUnmount() {
        clearInterval(this.state.time)
    }

    logout(nomsg = 0) {
        fetch('/Login/logout', {
            method: "POST",
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 1) {
                    this.props.history.push("/login")
                    if (nomsg != 0) {
                        // message.success(data.msg);
                    }
                } else {
                    this.setState({ isLogin: store.getState().data.isLogin })
                }
            })
    }

    render() {

        const menu = (<Menu
            items={[
                {
                    key: '1', label: (<Link to={{ pathname: '/geren' }}>个人资料</Link>), icon: <IdcardOutlined />
                }, {
                    key: '2',
                    label: (<Link to={{ pathname: '/mmxg' }}>密码修改</Link>),
                    icon: <PlusSquareOutlined />, // disabled: true,
                }
            ]}
        />);
        return (<>
            {/* {!isLogin ? */}
            {!this.state.ISlogin ? null : <>
                <Layout>
                    <Sider width={200} theme="dark">
                        <div className="logo">永泰园区运营系统</div>
                        <Menu mode="inline" theme="dark" className='leftmenu'
                            selectedKeys={[(store.getState().data.nav ? store.getState().data.nav : null)]}>
                            <Menu.Item key="/" icon={<AppstoreOutlined />} title="首页">
                                <Link to={{ pathname: '/' }}><span>首页</span></Link>
                            </Menu.Item>
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('1') ||
                                store.getState().data.info.lmqx_ck.includes('10') ?
                                <Menu.SubMenu title="合同管理" icon={<DollarCircleOutlined />}>
                                    {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('1') ?
                                        <Menu.Item key="/hetong" title="租赁合同">
                                            <Link to={{ pathname: '/hetong' }}><span>租赁合同</span></Link>
                                        </Menu.Item>
                                        : null) : null}
                                    {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('102') ?
                                        <Menu.Item key="/hetong_cs" title="合同管理">
                                            <Link to={{ pathname: '/hetong_cs' }}><span>测试合同</span></Link>
                                        </Menu.Item>
                                        : null) : null}
                                </Menu.SubMenu>
                                : null) : null}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('2') ?
                                <Menu.Item key="/fangjian" icon={<ShopOutlined />} title="房间管理">
                                    <Link to={{ pathname: '/fangjian' }}><span>房间管理</span></Link>
                                </Menu.Item>
                                : null) : null}
                            {store.getState().data.info.lmqx_ck ? (
                                store.getState().data.info.lmqx_ck.includes('301') ||
                                    store.getState().data.info.lmqx_ck.includes('302') ||
                                    store.getState().data.info.lmqx_ck.includes('303') ||
                                    store.getState().data.info.lmqx_ck.includes('304') ||
                                    store.getState().data.info.lmqx_ck.includes('305') ||
                                    store.getState().data.info.lmqx_ck.includes('306') ?
                                    <Menu.SubMenu title="缴费管理" icon={<DollarCircleOutlined />}>
                                        {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('301') ?
                                            <Menu.Item key="/jf_fz" title="房租">
                                                <Link to={{ pathname: '/jf_fz' }}><span>房租</span></Link>
                                            </Menu.Item>
                                            : null) : null}
                                        {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('302') ?
                                            <Menu.Item key="/jf_wyf" title="管理服务费">
                                                <Link to={{ pathname: '/jf_wyf' }}><span>管理服务费</span></Link>
                                            </Menu.Item>
                                            : null) : null}
                                        {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('303') ?
                                            <Menu.Item key="/jf_sf" title="水费">
                                                <Link to={{ pathname: '/jf_sf' }}><span>水费</span></Link>
                                            </Menu.Item>
                                            : null) : null}
                                        {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('304') ?
                                            <Menu.Item key="/jf_df" title="电费">
                                                <Link to={{ pathname: '/jf_df' }}><span>电费</span></Link>
                                            </Menu.Item>
                                            : null) : null}
                                        {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('305') ?
                                            <Menu.Item key="/jf_zlf" title="制冷费">
                                                <Link to={{ pathname: '/jf_zlf' }}><span>制冷费</span></Link>
                                            </Menu.Item>
                                            : null) : null}
                                        {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('306') ?
                                            <Menu.Item key="/jf_gnf" title="供暖费">
                                                <Link to={{ pathname: '/jf_gnf' }}><span>供暖费</span></Link>
                                            </Menu.Item>
                                            : null) : null}
                                        {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('307') ?
                                            <Menu.Item key="/jf_csf" title="测试费">
                                                <Link to={{ pathname: '/jf_csf' }}><span>测试费</span></Link>
                                            </Menu.Item>
                                            : null) : null}
                                        {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('308') ?
                                            <Menu.Item key="/jf_fwf" title="服务费">
                                                <Link to={{ pathname: '/jf_fwf' }}><span>服务费</span></Link>
                                            </Menu.Item>
                                            : null) : null}
                                    </Menu.SubMenu>
                                    : null) : null}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('4') ?
                                <Menu.Item key="/qiye" icon={<BuildOutlined />} title="企业信息">
                                    <Link to={{ pathname: '/qiye' }}><span>企业信息</span></Link>
                                </Menu.Item>
                                : null) : null}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('5') ?
                                <Menu.Item key="/caigou" icon={<ShoppingCartOutlined />} title="采购管理">
                                    <Link to={{ pathname: '/caigou' }}><span>采购管理</span></Link>
                                </Menu.Item>
                                : null) : null}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('11') ?
                                <Menu.Item key="/sjtj" icon={<PieChartOutlined />} title="数据统计">
                                    <Link to={{ pathname: '/sjtj' }}><span>数据统计</span></Link>
                                </Menu.Item>
                                : null) : null}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('12') ?
                                <Menu.Item key="/ztxm" icon={<AreaChartOutlined />} title="在谈项目">
                                    <Link to={{ pathname: '/ztxm' }}><span>在谈项目</span></Link>
                                </Menu.Item>
                                : null) : null}
                            {store.getState().data.info.lmqx_ck ? (
                                store.getState().data.info.lmqx_ck.includes('131') ||
                                    store.getState().data.info.lmqx_ck.includes('132') ?
                                    <Menu.SubMenu title="载体库" icon={<BankOutlined />}>
                                        {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('131') ?
                                            <Menu.Item key="/changfang" title="厂房">
                                                <Link to={{ pathname: '/changfang' }}><span>厂房</span></Link>
                                            </Menu.Item>
                                            : null) : null}
                                        {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('132') ?
                                            <Menu.Item key="/office" title="办公室">
                                                <Link to={{ pathname: '/office' }}><span>办公室</span></Link>
                                            </Menu.Item>
                                            : null) : null}
                                    </Menu.SubMenu>
                                    : null) : null}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('6') ?
                                <Menu.Item key="/user" icon={<UserOutlined />} title="账号管理">
                                    <Link to={{ pathname: '/user' }}><span>账号管理</span></Link>
                                </Menu.Item>
                                : null) : null}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('7') ?
                                <Menu.Item key="/czjl" icon={<VideoCameraOutlined />} title="操作记录">
                                    <Link to={{ pathname: '/czjl' }}><span>操作记录</span></Link>
                                </Menu.Item>
                                : null) : null}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('8') ?
                                <Menu.Item key="/backup" icon={<DatabaseOutlined />} title="数据备份">
                                    <Link to={{ pathname: '/backup' }}><span>数据备份</span></Link>
                                </Menu.Item>
                                : null) : null}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('9') ?
                                <Menu.Item key="/setting" icon={<SettingOutlined />} title="系统设置">
                                    <Link to={{ pathname: '/setting' }}><span>系统设置</span></Link>
                                </Menu.Item>
                                : null) : null}
                        </Menu>
                    </Sider>
                    <Layout>
                        <Header className="header">
                            <Row justify='space-between'>
                                <div>
                                    <Space>
                                        <span>选择园区</span>
                                        <Select
                                            style={{
                                                width: 180,
                                            }}
                                            onChange={(value) => this.props.SET_YUANQU(value)}
                                            value={this.state.yuanqu ? this.state.yuanqu : null}
                                            allowClear
                                            placeholder={'全部'}
                                            options={this.state.yuanqu_react}
                                        />
                                    </Space>
                                </div>
                                <div className='butr'>
                                    <Space size={15}>
                                        <Tooltip title="站内信">
                                            <Znxx />
                                        </Tooltip>
                                        <Tooltip title="复制新页面">
                                            <a href={'#' + this.props.location.pathname} target="_blank" style={{ color: '#000' }}>
                                                <CopyOutlined />
                                            </a>
                                        </Tooltip>
                                        <Dropdown overlay={menu} overlayStyle={{ width: 100 }}>
                                            <a onClick={(e) => e.preventDefault()} style={{ color: '#000' }}>
                                                <Space>
                                                    <Avatar size="small" icon={<UserOutlined />}
                                                        src={store.getState().data.info.tx} />
                                                    <span>{store.getState().data.info.name}</span>
                                                </Space>
                                            </a>
                                        </Dropdown>
                                        <PoweroffOutlined title='退出登录' onClick={this.logout.bind(this)} />
                                    </Space>
                                </div>
                            </Row>
                        </Header>
                        <Layout style={{ padding: '0 15px 15px', height: "calc(100vh - 64px)", overflow: 'auto' }}
                            className='scrollStyle'>
                            {(store.getState().data.nav != '/' && store.getState().data.nav != '/sjtj') ? <>
                                <Breadcrumb style={{ margin: '16px 0' }} separator=">">
                                    {this.breadcrumbItem()}
                                </Breadcrumb>
                                <Content
                                    className="site-layout-background"
                                    style={{
                                        padding: 15, margin: 0, minHeight: 280, overflow: 'auto'
                                    }}
                                    key={this.state.yuanqu}
                                >
                                    {this.props.children}
                                </Content>
                            </> : <div className="site-layout-background"
                                style={{
                                    backgroundColor: '#f0f2f5',
                                    height: 'calc(100vh - 80px)',
                                    paddingTop: 15,
                                    overflowY: 'auto'
                                }}
                                key={this.state.yuanqu}
                            >
                                {this.props.children}
                            </div>}
                        </Layout>
                    </Layout>
                </Layout>
            </>}
        </>);
    }
}

export default withRouter(SiderDemo);
